import React from 'react';
import { Alert } from 'react-bootstrap';
import { FaExclamationTriangle } from 'react-icons/fa';

/**
 * Component for displaying a warning about missing message IDs
 */
const MissingIdsWarning = ({ missingIds, show, onClose }) => {
    if (!show || missingIds.length === 0) {
        return null;
    }

    return (
        <Alert 
            variant="warning" 
            className="mb-4" 
            dismissible
            onClose={onClose}
        >
            <div className="d-flex align-items-center">
                <FaExclamationTriangle className="me-2" size={16} />
                <strong>Warning:</strong>
                <span className="ms-2">
                    Missing message IDs detected: {missingIds.join(', ')}
                </span>
            </div>
        </Alert>
    );
};

export default MissingIdsWarning;
